import { getMetaMatchParams, getUtmFromStorage } from './analytics';


export const createPurchaseEventId = (orderId = '') => {
  const safeOrderId = String(orderId || '')
    .replace(/[^a-zA-Z0-9._-]/g, '_')
    .slice(0, 80);
  return safeOrderId ? `purchase-${safeOrderId}` : 'purchase-invalid-order';
};


export const createStartTrialEventId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `start-trial-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};


export const buildStartTrialMetaPayload = ({
  eventId,
  triggerFeature,
  triggerPage,
} = {}) => ({
  trigger_feature: triggerFeature,
  trigger_page: triggerPage,
  event_id: eventId || createStartTrialEventId(),
  ...getMetaMatchParams(),
});


export const trackMetaStartTrialPixel = ({
  contentName,
  eventId,
} = {}) => {
  if (!eventId || typeof window === 'undefined' || typeof window.fbq !== 'function') {
    return false;
  }
  try {
    window.fbq('track', 'StartTrial', {
      content_name: contentName,
    }, { eventID: eventId });
    return true;
  } catch (_) {
    return false;
  }
};


export const trackMetaPurchasePixel = ({
  amount,
  eventId,
  orderId,
  planId,
}) => {
  if (!eventId || typeof window === 'undefined' || typeof window.fbq !== 'function') {
    return false;
  }
  const utm = getUtmFromStorage() || {};
  try {
    window.fbq('track', 'Purchase', {
      value: Number(amount) || 0,
      currency: 'KRW',
      content_ids: [planId],
      content_type: 'product',
      order_id: orderId,
      utm_source: utm.utm_source || undefined,
      utm_medium: utm.utm_medium || undefined,
      utm_campaign: utm.utm_campaign || undefined,
      utm_content: utm.utm_content || undefined,
    }, { eventID: eventId });
    return true;
  } catch (_) {
    return false;
  }
};
